<template>
  <div ref="body" style="position: relative; padding-bottom: 70px;" @mouseenter="divMouseenter">
    <div v-if="zoneId" class="tools">
      <vs-button class="py-0 px-3" type="border" color="secondary" style="background-color: #fff;" @click="onClick({id: 0, name: 0})">
        <div class="flex items-center" style="margin-top: 4px">
          <feather-icon icon="ChevronLeftIcon" style="width: 18px;"/>
          전체보기
        </div>
      </vs-button>
    </div>

    <div
      ref="tooltip"
      style="position: absolute; z-index: 1000; padding: 5px 10px; background-color: #fff; border: solid 2px #000; font-size: 14px; pointer-events: none; display: none;"
    ></div>

    <img
      ref="mapImage"
      :src="require('@/assets/images/도면/도면_포항공장.png')"
      alt=""
      usemap="#map2"
      class="w-full opacity-50"
      @load="updateCoords"
    />
    <svg
      viewBox="0 0 3584 2280"
      style="position: absolute; top: 0; left: 0; pointer-events: none;"
    >
      <template v-for="origin in original">
        <!-- 기존 polygon은 그대로 유지 -->
        <polygon v-if="origin.shape === 'poly'" :id="origin.id" fill="rgba(0, 0, 255, 0.3)" stroke="blue" :points="origin.coords" stroke-width="8" style="display: none" :key="`polygon_${origin.id}`"/>

        <!-- 중점대상일 때 삼각형 마커 -->
        <template v-if="origin.center && origin.isCritical && origin.edge > 0">
          <!-- 삼각형 그림자 -->
          <polygon
            :id="`${origin.id}_shadow`"
            :points="`${origin.center.x + 3},${origin.center.y - 48 + 3} ${origin.center.x - 48 + 3},${origin.center.y + 48 + 3} ${origin.center.x + 48 + 3},${origin.center.y + 48 + 3}`"
            fill="rgba(0,0,0,0.3)"
            :key="`triangle_shadow_${origin.id}`"
          />

          <!-- 삼각형 배경 -->
          <polygon
            :id="`${origin.id}_triangle`"
            :points="`${origin.center.x},${origin.center.y - 48} ${origin.center.x - 48},${origin.center.y + 48} ${origin.center.x + 48},${origin.center.y + 48}`"
            fill="#FF6B6B"
            stroke="#FF4757"
            stroke-width="2"
            :key="`triangle_${origin.id}`"
          />

          <!-- 삼각형 내부 텍스트 -->
          <text
            :id="`${origin.id}_text`"
            :x="origin.center.x"
            :y="origin.center.y + 12"
            fill="#fff"
            font-size="48px"
            text-anchor="middle"
            font-weight="600"
            alignment-baseline="middle"
            :key="`triangle_text_${origin.id}`"
          >
            {{ origin.edge }}
          </text>
        </template>

        <!-- 일반일 때 원형 마커 -->
        <template v-else-if="origin.center">
          <!-- 마커 배경 - 그림자 추가 -->
          <circle
            :id="`${origin.id}_shadow`"
            :cx="origin.center.x + 3"
            :cy="origin.center.y + 3"
            :r="origin.edge > 0 ? 54 : 32"
            fill="rgba(0,0,0,0.3)"
            :key="`shadow_${origin.id}`"
          />

          <!-- 마커 배경 -->
          <circle
            :id="`${origin.id}_circle`"
            :cx="origin.center.x"
            :cy="origin.center.y"
            :r="origin.edge > 0 ? 54 : 32"
            :fill="origin.edge > 0 ? 'rgba(220, 53, 69, 0.9)' : 'rgba(255, 255, 255, 0.9)'"
            :stroke="origin.edge > 0 ? '#c82333' : '#dee2e6'"
            stroke-width="2"
            :key="`circle_${origin.id}`"
          />

          <!-- 마커 내부 텍스트 -->
          <text
            :id="`${origin.id}_text`"
            :x="origin.center.x"
            :y="origin.center.y"
            :fill="origin.edge > 0 ? '#fff' : '#495057'"
            :font-size="origin.edge > 0 ? '48px' : '28px'"
            text-anchor="middle"
            font-weight="600"
            alignment-baseline="middle"
            :key="`text_${origin.id}`"
          >
            {{ origin.edge }}
          </text>
        </template>
      </template>

      <!-- 선택된 마커 스타일도 동일하게 수정 -->
      <template v-if="selectZone && selectZone.center">
        <polygon v-if="selectZone" id="currentZone" fill="rgba(0, 0, 255, 0.3)" stroke="blue" :points="selectZone.coords" stroke-width="8"/>

        <!-- 선택된 마커 그림자 -->
        <circle
          id="currentZone_shadow"
          :cx="selectZone.center.x + 3"
          :cy="selectZone.center.y + 3"
          r="28"
          fill="rgba(0,0,0,0.3)"
        />

        <!-- 선택된 마커 배경 -->
        <circle
          id="currentZone_circle"
          :cx="selectZone.center.x"
          :cy="selectZone.center.y"
          r="28"
          fill="rgba(220, 53, 69, 0.9)"
          stroke="#c82333"
          stroke-width="2"
        />

        <!-- 선택된 마커 텍스트 -->
        <text
          id="currentZone_text"
          :x="selectZone.center.x"
          :y="selectZone.center.y"
          fill="#fff"
          font-size="24px"
          text-anchor="middle"
          font-weight="600"
          alignment-baseline="middle"
        >
          {{ selectZone.edge }}
        </text>
      </template>
    </svg>

    <map name="map2">
      <area
        v-for="(s, index) in scaled"
        :key="index"
        :shape="s.shape"
        :coords="s.coords"
        href="#"
        @mouseover="showPolygon(s)"
        @mouseout="hidePolygon(s)"
        @click="onClick(s)"
      />
    </map>

    <!-- 범례 -->
    <div class="tools" style="top:auto; bottom: 10px; left: 50%; transform: translateX(-50%)">
      <div class="grid" style="grid-template-columns: auto auto; border: 1px solid #999999;">
        <span class="px-1" style="width: 8px; background-color: #999999; color:#fff;"></span>
        <div class="flex gap-4 p-2 font-bold">
          <div class="flex items-center gap-1">
            <div class="grid place-items-center rounded-full" style="width:32px; height: 32px; background-color: rgba(220, 53, 69, 0.9); color: #fff; font-size: 16px; font-weight: 600;"></div>
            일반작업
          </div>
          <div class="flex items-center gap-1">
            <div class="rounded-none"
                 style="width:32px; height:32px; padding-top: 6px;
              background-color: #FF4757;
              color:#fff; font-size:16px; font-weight:600;
              display:flex; align-items:center; justify-content:center;
              clip-path: polygon(50% 0%, 0% 100%, 100% 100%);"></div>
            중점대상현황
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "MapFactoryAccess2",
  props: {
    value: [String, Number],
    markers: Array,
  },
  data () {
    return {
      zoneId: this.value,
      selectZone: null,
      width: 3584,
      height: 2280,
      original: [
        { id: "27", label: "1후판공장", edge: "0", shape: "poly", coords: "788,518,1148,520,1148,1319,1021,1321,1022,1473,1053,1475,1056,1793,754,1791,755,1467,790,1468" },
        { id: "28", label: "1후판 수처리", edge: "0", shape: "poly", coords: "877,382,1117,382,1117,484,877,484" },
        { id: "29", label: "1후판 야적장", edge: "0", shape: "poly", coords: "763,496,764,357,516,364,420,399,395,421,388,457,388,820,434,951,472,967,508,1002,601,1003,607,503" },
        { id: "30", label: "후판 154 변전소", edge: "0", shape: "poly", coords: "258,511,352,511,352,611,258,611" },
        { id: "31", label: "풋살구장", edge: "0", shape: "poly", coords: "296,650,369,650,369,738,296,738" },
        { id: "32", label: "부산물장", edge: "0", shape: "poly", coords: "635,1124,770,1123,770,1434,719,1434,687,1400,632,1307" },
        { id: "116", label: "1후판 스카핑장", edge: "0", shape: "poly", coords: "617,531,776,531,776,1081,617,1081" },

        { id: "34", label: "2후판 공장", edge: "0", shape: "poly", coords: "1230,1012,1232,1306,1493,1305,1493,1164,1842,1167,1842,1081,2113,1080,2112,1000,2639,1001,2641,1079,2735,1080,2734,1101,3190,1101,3191,780,2736,782,2736,834,2674,834,2675,778,2470,778,2471,834,2349,833,2350,778,2307,777,2308,835,2278,834,2279,777,2023,778,2024,834,1889,834,1890,1024,1842,1025,1842,957,1680,957,1681,879,1534,879,1535,958,1438,957,1437,1013" },
        { id: "35", label: "GFRP, BH Line", edge: "0", shape: "poly", coords: "2113,1001,2641,1001,2641,1080,2113,1080" },
        { id: "36", label: "2후판 수처리", edge: "0", shape: "poly", coords: "1445,771,1445,939,1496,938,1496,873,1717,872,1716,771" },
        { id: "37", label: "산소절단장", edge: "0", shape: "poly", coords: "1227,766,1319,768,1318,776,1398,776,1397,925,1317,924,1318,1009,1225,1008" },

        { id: "39", label: "SLAB YARD", edge: "0", shape: "poly", coords: "1206,382,1394,382,1394,720,1206,720" },
        { id: "40", label: "SLAG DUMPING장", edge: "0", shape: "poly", coords: "1404,369,1463,369,1463,709,1404,709" },
        { id: "41", label: "고철장", edge: "0", shape: "poly", coords: "1492,368,2019,368,2019,663,1492,663" },
        { id: "42", label: "집진기, 수처리", edge: "0", shape: "poly", coords: "1492,664,2494,664,2494,719,1492,719" },
        { id: "43", label: "전기로, LF", edge: "0", shape: "poly", coords: "2020,367,2179,367,2179,664,2020,664" },
        { id: "44", label: "연주", edge: "0", shape: "poly", coords: "2353,368,2353,475,2242,474,2242,642,2182,640,2181,365" },
        { id: "45", label: "소재 YARD", edge: "0", shape: "poly", coords: "2243,474,2386,474,2386,642,2243,642" },

        { id: "47", label: "형강 가열로", edge: "0", shape: "poly", coords: "2577,423,2577,368,2353,368,2353,476,2386,475,2387,644,2448,644,2448,530,2498,531,2498,424" },
        { id: "48", label: "형강 압연", edge: "0", shape: "poly", coords: "2495,475,2876,475,2876,531,2495,531" },
        { id: "49", label: "형강 ROLL SHOP", edge: "0", shape: "poly", coords: "2496,423,2647,423,2648,375,3183,377,3184,473,2496,475" },
        { id: "50", label: "형강 제품창고", edge: "0", shape: "poly", coords: "2539,719,2535,574,2876,576,2876,615,3177,618,3178,719" },
        { id: "51", label: "형강 154 변전소", edge: "0", shape: "poly", coords: "3279,392,3347,392,3347,484,3279,484" },
        { id: "117", label: "형강정정", edge: "0", shape: "poly", coords: "2533,529,2535,576,2875,577,2876,616,3179,617,3182,471,2876,472,2876,530" },

        { id: "53", label: "CS 가열로", edge: "0", shape: "poly", coords: "3138,1851,3211,1851,3211,2025,3138,2025" },
        { id: "54", label: "CS 압연", edge: "0", shape: "poly", coords: "2758,1945,3140,1945,3140,2009,2758,2009" },
        { id: "55", label: "CS 정정", edge: "0", shape: "poly", coords: "2411,1875,2413,1989,2763,1989,2756,1941,3136,1946,3135,1899,2915,1900,2917,1876" },
        { id: "56", label: "CS 제품창고", edge: "0", shape: "poly", coords: "2416,1778,2917,1778,2917,1853,2416,1853" },
        { id: "57", label: "CS ROLL SHOP", edge: "0", shape: "poly", coords: "2921,1829,3137,1829,3137,1902,2921,1902" },
        { id: "58", label: "CS 수처리", edge: "0", shape: "poly", coords: "2415,2013,2794,2013,2794,2085,2415,2085" },

        { id: "60", label: "2생산동", edge: "0", shape: "poly", coords: "1732,887,1866,887,1866,943,1732,943" },
        { id: "61", label: "2협력동", edge: "0", shape: "poly", coords: "1869,776,2002,776,2002,821,1869,821" },
        { id: "62", label: "CS생산동", edge: "0", shape: "poly", coords: "3278,1363,3348,1363,3348,1520,3278,1520" },
        { id: "63", label: "본관 사무동", edge: "0", shape: "poly", coords: "1217,1332,1471,1332,1471,1464,1217,1464" },
        { id: "64", label: "중앙시험실", edge: "0", shape: "poly", coords: "2369,781,2464,781,2464,833,2369,833" },
        { id: "65", label: "ESS", edge: "0", shape: "poly", coords: "3304,529,3348,529,3348,664,3304,664" },
      ],
      scaled: [],
    }
  },
  computed: {
    imgWidth() {
      return this.$refs.mapImage ? this.$refs.mapImage.clientWidth : 0;
    },
  },
  watch: {
    imgWidth:{
      handler() {
        this.updateCoords();
      },
      immediate: true,
    },
    markers (markers) {
      this.original.forEach((origin, i) => {
        markers.forEach((marker) => {
          if (`${origin.id}` === `${marker.id}`) {
            this.original[i].edge = marker.edge;
            this.original[i].isCritical = marker.isCritical; // 중점대상 여부 추가
          }
        });
      });
    }
  },
  mounted() {
    this.updateCoords();
    window.addEventListener("resize", this.updateCoords); // 창 크기 변경 시 좌표 갱신
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateCoords); // 이벤트 제거
  },
  methods: {
    updateCoords() {
      const img = this.$refs.mapImage;
      if (img) {
        const scaleX = img.clientWidth / this.width; // 원본 너비에 대한 스케일
        const scaleY = img.clientHeight / this.height; // 원본 높이에 대한 스케일

        // 도형의 중심을 계산하여 원 추가
        for (let i = 0; i<this.original.length; i++) {
          const coords = this.original[i];
          let center = {};
          if (coords.shape === "poly") {
            center = this.calculatePolygonCenter(coords.coords);
          } else if (coords.shape === "rect") {
            center = this.calculateRectCenter(coords.coords);
          }

          this.original[i].center = {
            x: center.x,
            y: center.y
          };
        }


        // 원본 좌표를 스케일에 맞게 변환
        this.scaled = this.original.map((coords) => {
          const coordsData = {
            id: coords.id,
            label: coords.label,
            shape: coords.shape,
            coords: coords.coords
              .split(",")
              .map((value, index) => {
                const scale = index % 2 === 0 ? scaleX : scaleY; // X 좌표와 Y 좌표에 따라 다른 스케일 적용
                return Math.round(value * scale); // 스케일링 후 반올림
              })
              .join(",")
          }
          return coordsData;
        });

      }
    },
    // 다각형의 중심을 계산하는 함수
    calculatePolygonCenter(coords) {
      const points = coords.split(",").map(Number);
      let x = 0, y = 0;
      const numPoints = points.length / 2;

      for (let i = 0; i < numPoints; i++) {
        x += points[i * 2];
        y += points[i * 2 + 1];
      }

      return {
        x: x / numPoints,
        y: y / numPoints
      };
    },

    // 사각형의 중심을 계산하는 함수
    calculateRectCenter(coords) {
      const [x1, y1, x2, y2] = coords.split(",").map(Number);
      return {
        x: (x1 + x2) / 2,
        y: (y1 + y2) / 2
      };
    },

    // 다각형 표시
    showPolygon(ss) {
      const id = ss.id
      const el = document.getElementById(id)
      if (el) {
        document.getElementById(id).style.display = 'block';
        const rectPosition = el.getBoundingClientRect();
        const parentPosition = this.$refs.body.getBoundingClientRect();
        this.$refs.tooltip.style.display = '';
        this.$refs.tooltip.style.top = `${rectPosition.top - parentPosition.top - 40}px`;
        this.$refs.tooltip.style.left = `${rectPosition.left - parentPosition.left}px`;
        this.$refs.tooltip.textContent = ss.label;
      }
    },
    hidePolygon(ss) {
      const id = ss.id
      if (document.getElementById(id)) {
        document.getElementById(id).style.display = 'none';
      }
      this.$refs.tooltip.style.display = 'none';
    },

    onClick (ss) {
      this.zoneId = ss.id;
      const find = this.original.find((item) => item.id === ss.id);
      if (find) {
        this.selectZone = find;
      } else {
        this.selectZone = null;
      }
      this.$emit("click", {id: ss.id, name: ss.label})
    },

    resetSelectZone() {
      this.selectZone = null;
    },

    divMouseenter() {
      this.updateCoords();
    },
  },
}
</script>

<style scoped>
circle.active {
  r: 54;
  fill: red;
  stroke: red;
  stroke-width: 4;
}
text.active {
  fill: #fff;
  font-size: 48px;
  font-weight: bold;
}
.tools {
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 100;
  background-color: #fff;
  border-radius: 6px;
}
</style>
